import { Box, Typography } from "@mui/material";
import { RacwaCardNotification } from "@racwa/react-components";
import { InsurancePhoneNumberLink } from "raci-react-library";
import React from "react";

/* TODO: RACDS-13 card to be provided by the design system library */
export interface NotFoundCardProps extends React.ComponentProps<any> {
  visible?: boolean | false;
  isContactMatchAttemptsExhausted?: boolean | false;
}

interface cardMessage {
  title: string;
  firstParagraph: string;
  secondParagraph?: string;
  thirdParagraph?: string;
}

export const defaultMessage: cardMessage = {
  title: "We couldn't find your details",
  firstParagraph: "Please check that you've entered your personal information correctly.",
  secondParagraph: "Alternatively, if you're known by different names try your legal or preferred name.",
  thirdParagraph: "If we still can't find your details select skip to continue and we'll try again later.",
};

export const attemptsExhaustedMessage: cardMessage = {
  title: "We still couldn't find your details",
  firstParagraph: "Select Skip to continue.",
};

export const NotFoundCard = ({ visible, isContactMatchAttemptsExhausted }: NotFoundCardProps) => {
  const message = isContactMatchAttemptsExhausted ? attemptsExhaustedMessage : defaultMessage;

  return visible ? (
    <RacwaCardNotification data-testid="notFoundCard" severity="warning" title={message.title}>
      <Box marginBottom={1}>
        <Typography variant="body2">{message.firstParagraph}</Typography>
      </Box>
      {message.secondParagraph === defaultMessage.secondParagraph && (
        <Box marginBottom={1}>
          <Typography variant="body2">{message.secondParagraph}</Typography>
        </Box>
      )}
      {message.thirdParagraph === defaultMessage.thirdParagraph && (
        <Box marginBottom={1}>
          <Typography variant="body2">{message.thirdParagraph}</Typography>
        </Box>
      )}
    </RacwaCardNotification>
  ) : null;
};

export default NotFoundCard;
